/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import { useLocation } from '@reach/router';
import { useStaticQuery, graphql, withPrefix } from 'gatsby';
import { Helmet, HelmetProps } from 'react-helmet';

const replaceKey = '%s';

export type SeoProps = {
  title?: string;
  templateTitle?: string;
  description?: string;
  ogimage?: string;
  meta?: HelmetProps['meta'];
};

export const Seo: React.FC<SeoProps> = ({
  title,
  templateTitle,
  description = '',
  ogimage = '',
  meta = [],
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
          }
        }
      }
    `,
  );

  const { pathname } = useLocation();

  const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = site.siteMetadata?.title;
  const template = templateTitle || `${replaceKey}｜${defaultTitle}`;
  
  let setogimage = `${site.siteMetadata?.siteUrl}${withPrefix('/ogp.png')}`;
  if(ogimage){
    setogimage = ogimage;
  }
  
  return (
    <Helmet
      htmlAttributes={{
        lang: 'ja',
      }}
      title={title ? template.replace(replaceKey, title) : defaultTitle}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title ? title : defaultTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:image`,
          content: setogimage,
        },
        {
          property: `og:locale`,
          content: 'ja_JP',
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:url`,
          content: `${site.siteMetadata?.siteUrl}${pathname}`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        ...meta,
      ]}
    >
    <script async='async' src='https://mm-uxrv.com/js/semrush_0f6967a8-4d2c-4bc4-bb57-4bab0981c6d1-50296172.js'></script>
    </Helmet>
  );
};
